<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout v-if="driverApplication" pl-2 pt-2 pr-2 pb-2 justify-center row>
    <v-flex xs2>
      <v-layout column>
        <SimpleCard>
          <DriverApplicationOptionsBox :driverApplication="driverApplication"></DriverApplicationOptionsBox>
        </SimpleCard>
      </v-layout>
    </v-flex>
    <v-flex xs10 pl-2>
      <v-flex mb-2>
        <SimpleCard>
          <v-row justify="center">
            <v-flex shrink>
              <p
                v-bind:style="{'color': colorForApplicationStatus, 'fontWeight': 800, 'fontSize': '22px'}"
              >APPLICATION STATUS: {{applicationStatus}}</p>
            </v-flex>
          </v-row>
        </SimpleCard>
      </v-flex>
      <SimpleCard>
        <v-col>
          <h3 style="padding-bottom: 8px;">Driver Details</h3>
          <v-row wrap>
            <img
              style="height: auto; max-height: 180px; display: block; max-width: 180px; width: auto;"
              :src="driverApplication.driverSignupDetails.pictureURL"
            />
            <v-flex shrink pl-3 pr-3>
              <v-col style="font-size: 14px;">
                <h4>Contact Information</h4>
                <p>{{user.name}}</p>
                <a
                  v-on:click.stop="doNothing()"
                  :href="'tel:'+formatNumber(user.contactNumber)"
                >{{ user.contactNumber }}</a>
                <br />
                <a v-on:click.stop="doNothing()" :href="'mailto:'+(user.email)">{{ user.email }}</a>
              </v-col>
            </v-flex>
            <v-divider vertical />
            <v-flex pl-3 pr-3 shrink>
              <v-col style="font-size: 14px;">
                <h4>Address</h4>
                <p v-if="dsd.homeNumber">{{dsd.homeNumber}}</p>
                <p v-if="dsd.address1">{{dsd.address1}}</p>
                <p v-if="dsd.address2">{{dsd.address2}}</p>
                <p v-if="dsd.town">{{dsd.town}}</p>
                <p v-if="dsd.county">{{dsd.county}}</p>
                <p v-if="dsd.postcode">{{dsd.postcode}}</p>
              </v-col>
            </v-flex>
            <v-divider vertical />
            <v-flex pl-3 pr-3 shrink>
              <v-col style="font-size: 14px;">
                <h4>Licences</h4>
                <h5>Driver Licence Number</h5>
                <p>{{dsd.licenceNumber}}</p>
                <h5>Licence Renewal Date</h5>
                <p>{{formatDate(dsd.licenceRenewalDate)}}</p>
                <h5 v-if="dsd.hireNumber">Private Hire Number</h5>
                <p v-if="dsd.hireNumber">{{dsd.hireNumber}}</p>
                <h5 v-if="dsd.hireNumberRenewalDate">PH Renewal Date</h5>
                <p v-if="dsd.hireNumberRenewalDate">{{formatDate(dsd.hireNumberRenewalDate)}}</p>
                <h5 v-if="dsd.hackneyNumber">Hackney Number</h5>
                <p v-if="dsd.hackneyNumber">{{dsd.hackneyNumber}}</p>
                <h5 v-if="dsd.hackneyNumberRenewalDate">Hackney Renewal Date</h5>
                <p v-if="dsd.hackneyNumberRenewalDate">{{formatDate(dsd.hackneyNumberRenewalDate)}}</p>
              </v-col>
            </v-flex>
            <v-divider vertical />
            <v-flex pl-3 pr-3 shrink>
              <v-col style="font-size: 14px;">
                <h4>Qualifications</h4>
                <p v-if="dsd.wheelChairCertificate">Wheelchair Certificate</p>
                <p v-if="dsd.btech">B-Tech</p>
                <p v-if="dsd.adt">Advanced Driver Training (ADT)</p>
                <p v-if="dsd.nvq">National Vocational Qualification (NVQ)</p>
              </v-col>
            </v-flex>
          </v-row>
        </v-col>
      </SimpleCard>
      <v-flex mt-2>
        <SimpleCard>
          <v-col>
            <h3 style="padding-bottom: 8px;">Vehicle Details</h3>
            <v-row wrap>
              <v-flex pr-3 shrink>
                <v-col style="font-size: 14px;">
                  <h4>Vehicle</h4>
                  <h5>Make</h5>
                  <p>{{taxi.make}}</p>
                  <h5>Model</h5>
                  <p>{{taxi.model}}</p>
                  <h5>Color</h5>
                  <p>{{taxi.colour}}</p>
                  <h5>Body Style</h5>
                  <p>{{taxi.type}}</p>
                  <h5>Num Seats</h5>
                  <p>{{taxi.numSeats}}</p>
                </v-col>
              </v-flex>
              <v-divider vertical />
              <v-flex pl-3 pr-3 shrink>
                <v-col style="font-size: 14px;">
                  <h4>Vehicle Capabilities</h4>
                  <p v-if="taxi.disabledAccess">Disabled Access</p>
                  <p v-if="taxi.premium">Premium</p>
                  <p v-if="taxi.wide">Wide</p>
                  <p v-if="taxi.petsAllowed">Pets Allowed</p>
                  <p v-if="taxi.hackneyCarriage">Hackney Carriage</p>
                </v-col>
              </v-flex>
              <v-divider vertical />
              <v-flex pl-3 pr-3 shrink>
                <v-col style="font-size: 14px;">
                  <h4>Insurance &amp; Licencing</h4>
                  <h5>Council</h5>
                  <p>{{taxi.council}}</p>
                  <h5>Insurance Certificate Number</h5>
                  <p>{{taxi.insuranceCertificateNumber}}</p>
                  <h5>Insurance Expiry Date</h5>
                  <p>{{formatDate(taxi.insuranceValidUntil)}}</p>
                  <h5>Road Tax Expiry Date</h5>
                  <p>{{formatDate(taxi.roadTaxValidUntil)}}</p>
                  <h5>Compliance Certificate Expiry Date</h5>
                  <p>{{formatDate(taxi.complianceCertificateExpiry)}}</p>
                  <h5>MOT Expiry Date</h5>
                  <p>{{formatDate(taxi.motValidUntil)}}</p>
                </v-col>
              </v-flex>
            </v-row>
          </v-col>
        </SimpleCard>
      </v-flex>
      <v-flex mt-2>
        <SimpleCard>
          <v-col>
            <h3 style="padding-bottom: 8px;">Document Uploads</h3>
          </v-col>
        </SimpleCard>
      </v-flex>
      <v-flex mt-2>
        <SimpleCard>
          <DriverSignupDocuments :driverDocuments="driverDocuments"></DriverSignupDocuments>
        </SimpleCard>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";

import SimpleCard from "@/components/widget/SimpleCard.vue";
import DriverList from "@/components/driver/DriverList.vue";
import Timesheet from "@/components/driver/Timesheet.vue";
import DriverApplicationOptionsBox from "@/components/driver/DriverApplicationOptionsBox.vue";
import DriverSignupDocuments from "@/components/driver/DriverSignupDocuments.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import { replaceStart } from "@/components/util/PhoneNumbers.js";

export default {
  name: "driver_application",
  components: {
    SimpleCard,
    DriverList,
    DriverApplicationOptionsBox,
    Timesheet,
    DriverSignupDocuments
  },
  data: function() {
    return {
      driverApplication: null,
      driverDocuments: null,
      loading: true
    };
  },
  mounted: async function() {
    this.getDriverApplication();
    this.getDriverUploadedDocuments();
  },
  computed: {
    dsd: function() {
      return this.driverApplication.driverSignupDetails;
    },
    user: function() {
      return this.driverApplication.user;
    },
    taxi: function() {
      return this.driverApplication.taxiSignupInformation;
    },
    applicationStatus: function() {
      if (this.driverApplication.rejected == null) {
        if (this.driverApplication.submitted) {
          return "SUBMITTED";
        } else {
          return "IN PROGRESS";
        }
      } else {
        if (this.driverApplication.rejected) {
          return "REJECTED";
        } else {
          return "ACCEPTED";
        }
      }
    },
    colorForApplicationStatus: function() {
      if (this.driverApplication.rejected == null) {
        if (this.driverApplication.submitted) {
          return "green";
        } else {
          return "blue";
        }
      } else {
        if (this.driverApplication.rejected) {
          return "red";
        } else {
          return "green";
        }
      }
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getDriverApplication: async function() {
      this.loading = true;

      try {
        var url = `${this.$store.state.apiUrl}/driver_signup/${this.$route.params.id}/get`;

        let response = await axios.get(url, {
          params: {}
        });

        this.driverApplication = response.data;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get driver application " + error);
      }
    },
    getDriverUploadedDocuments: async function() {
      this.loading = true;

      try {
        var url = `${this.$store.state.apiUrl}/driver_signup/${this.$route.params.id}/getDocuments`;

        let response = await axios.get(url, {
          params: {}
        });

        this.driverDocuments = response.data.documents;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get driver signup documents " + error);
      }
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.error);
    },
    formatNumber: function(number) {
      return replaceStart(number);
    }
  }
};
</script>

<style  lang="scss">
h4 {
  padding-top: 3px;
  padding-bottom: 3px;
}
</style>